/*
 app dependencies
 - var body

 lib dependencies
*/

const scSidebarFilters = (function($)
{
    //public
    const   sidebarId = 'statement-filters';
    //private
    const   _filterButtonWrap = document.querySelector('.js-filter-btn-wrap');
    let     _sidebarDiv,
            _form,
            _jsFiltersModule = false,
            _ajaxByPopState = false;

	//module functions
    function contentLoaded(sidebarDiv, jsFiltersModule)
    {
        //references to elements / objects
        _sidebarDiv = sidebarDiv;
        _form = _sidebarDiv.querySelector('form');
        _jsFiltersModule = jsFiltersModule;

        //init
        scOptionSearch.init(sidebarDiv);

        _form.addEventListener('submit', function(e)
        {
            e.preventDefault();

            const newUrl = _getSearchUrl();

            //hide sidebar
            scSidebar.hide();

            //show overview loader
            document.querySelector(_jsFiltersModule.overviewWrapSelector).classList.add('loading-container--loading');

            //ajax call
            doAjax({
                ajaxUrl: newUrl,
                onSuccess: _onUpdateSuccess,
                onError: _onUpdateError,
                params: {
                    newUrl
                }
            });
        });

        /*window.addEventListener("popstate", function(e)
        {
            //handle browser forward / back

            //restore form values
            if (e.state === null || !e.state.formValues)
            {
                //initial state
                _jsFiltersModule.restoreInitialFormValues();
            }
            else
            {
                _jsFiltersModule.setFormValues(e.state.formValues);
            }

            //restore summary (based on form values)
            _jsFiltersModule.updateSummary();

            //trigger ajax call (by pop state)
            _ajaxByPopState = true;
            const submitEvent = document.createEvent('HTMLEvents');
            submitEvent.initEvent('submit', true, true);
            _form.dispatchEvent(submitEvent);
        });*/
    }

        function _getSearchUrl()
        {
            const params = $(_form).find("input").filter(function()
            {
                return this.value.trim().length > 0
            }).serialize();

            return `${_form.getAttribute('action')}?${params}`;
        }

        function _onUpdateSuccess(response, params)
        {
            document.querySelector(_jsFiltersModule.overviewWrapSelector).classList.remove('loading-container--loading');

            try
            {
                //parse html from response
                const parser = new DOMParser();
                const loadedDoc = parser.parseFromString(response, "text/html");
                const newOverviewWrap = loadedDoc.querySelector(_jsFiltersModule.overviewWrapSelector);
                if (newOverviewWrap)
                {
                    const newHtml = newOverviewWrap.outerHTML;
                    //set new html
                    document.querySelector(_jsFiltersModule.overviewWrapSelector).outerHTML = newHtml;

                    //push state unless triggered by browser forward / back
                    if (!_ajaxByPopState)
                    {
                        /*history.pushState({
                            formValues: _jsFiltersModule.getFormValues()
                        }, document.title, params.newUrl);*/
                        history.pushState({}, document.title, params.newUrl);

                        _jsFiltersModule.updateSummary();
                    }

                    //reset triggered by pop state
                    _ajaxByPopState = false;
                }
                else
                {
                    throw 'Er is iets misgegaan bij het ophalen van de resultaten';
                }
            }
            catch (err)
            {
                _ajaxByPopState = false;
                lmnDialog.alert(`<p>${err}</p>`);
            }
        }

        function _onUpdateError(jqxhr, textStatus, errorThrown, params)
        {
            document.querySelector(_jsFiltersModule.overviewWrapSelector).classList.remove('loading-container--loading');
            //error?
            if (!userAbortedAjax(jqxhr)) lmnDialog.alert(errorThrown);
        }


    function updateState()
    {
        //content has been loaded before, update form values
        _jsFiltersModule.setFormValues(getAllUrlParams());

        //restore summary (based on form values)
        _jsFiltersModule.updateSummary();

        //trigger ajax call (by pop state)
        _ajaxByPopState = true;
        const submitEvent = document.createEvent('HTMLEvents');
        submitEvent.initEvent('submit', true, true);
        _form.dispatchEvent(submitEvent);
    }



	//reveal public vars and functions
	return {
		//functions
		//init,
        contentLoaded,
        updateState
	};

})(jQuery);
